// @flow

import capitalize from 'lodash/capitalize';
import map from 'lodash/map';
import { isFutureDate } from 'clark-utils';
import { isRequired, isTime, normalizeTime } from '@clark-inc/clark-forms';
import DAYS_OF_WEEK from 'constants/days-of-week';

const weekdayDropdownOptions: Array<{ value: number, label: string }> = map(
  DAYS_OF_WEEK,
  (w, i) => ({
    value: i + 1,
    label: capitalize(w),
  }),
);

const formatDateFields = (
  isEndTimeLocked: boolean,
  isSchedulable: boolean,
  isEditRecurringEnabled: boolean,
) => {
  const dateSelect = isEditRecurringEnabled
    ? {
        columns: { small: 1, large: 1 },
        fields: [
          {
            type: 'dropdown',
            name: 'selectedWeekday',
            label: 'Which Day of the Week',
            values: weekdayDropdownOptions,
            validate: [isRequired],
          },
        ],
      }
    : {
        columns: { small: 1, large: 1 },
        fields: [
          {
            type: 'datepicker',
            name: 'startDate[date]',
            label: 'Date',
            showTimeSelect: true,
            dateFormat: 'LLL',
            validate: [isRequired],
            isOutsideRange: isSchedulable ? () => false : isFutureDate,
          },
        ],
      };

  const fieldSet = [
    dateSelect,
    {
      columns: { small: 2, large: 2 },
      fields: [
        {
          type: 'input',
          name: 'startTime[time]',
          label: 'Start Time',
          placeholder: '12:00',
          normalize: normalizeTime,
          validate: [isRequired, isTime],
        },
        {
          type: 'toggleButton',
          name: 'startTime[period]',
          values: [{ label: 'AM', value: 'am' }, { label: 'PM', value: 'pm' }],
          validate: isRequired,
        },
      ],
    },
    {
      columns: { small: 2, large: 2 },
      fields: [
        {
          type: 'input',
          name: 'endTime[time]',
          placeholder: '1:00',
          label: 'End Time',
          normalize: normalizeTime,
          validate: [isRequired, isTime],
          disabled: isEndTimeLocked,
          tooltip:
            isEndTimeLocked &&
            'Duration is not editable because this sesssion is associated with an invoice.',
        },
        {
          type: 'toggleButton',
          name: 'endTime[period]',
          values: [{ label: 'AM', value: 'am' }, { label: 'PM', value: 'pm' }],
          validate: isRequired,
          disabled: isEndTimeLocked,
        },
      ],
    },
    {
      columns: { small: 1, large: 1 },
      fields: [
        {
          type: 'locationAutocomplete',
          name: 'locationRaw',
          label: 'Location',
        },
      ],
    },
  ];

  return [
    {
      fieldSet,
    },
  ];
};

export default formatDateFields;



// WEBPACK FOOTER //
// ./src/containers/sessions/edit-form/date-fields/fieldset.js